import { render } from "./SelectPoli.vue?vue&type=template&id=75c2de5a&scoped=true"
import script from "./SelectPoli.vue?vue&type=script&lang=js"
export * from "./SelectPoli.vue?vue&type=script&lang=js"

import "./SelectPoli.vue?vue&type=style&index=0&id=75c2de5a&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c2de5a"]])

export default __exports__